import styled from "@emotion/styled";
import "swiper/css";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: start;

  inline-size: 120px;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 160px;
  }
`;

export const ThumbnailContainer = styled.div`
  position: relative;
`;

export const StyledBaseImage = styled(BaseImage)`
  inline-size: 120px;
  block-size: 80px;

  border-radius: 6px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 160px;
    block-size: 107px;
  }
`;

export const DurationBadge = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;

  block-size: 24px;
  padding: 4px;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  border-start-end-radius: 4px;

  background: #ffffff;
`;

export const Headline = styled.div`
  display: -webkit-box;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 130%;

  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  overflow: hidden;
`;
